import { z } from "zod";
import { ReportIdSchema, ScanIdSchema } from "../primitives/ids.js";
import { ExternalScanProjectContextV1Schema } from "./external-site-proof.js";
import { TraceContextSchema } from "./trace.js";
/** external-scan-job-payload.v1.0 — BullMQ worker job for public URL scans. */
export const ExternalScanJobPayloadV1Schema = z
    .object({
    schemaVersion: z.literal("external-scan-job-payload.v1.0"),
    jobKind: z.literal("SCAN_EXTERNAL_URL"),
    scanId: ScanIdSchema,
    publicReportRef: ReportIdSchema,
    normalizedUrl: z.string().url(),
    trace: TraceContextSchema,
    projectContext: ExternalScanProjectContextV1Schema.optional(),
    afterFixProofContext: z
        .object({
        afterFixProofId: z.string().regex(/^afproof_ext_/),
        priorScanId: ScanIdSchema,
        priorSnapshotId: z.string().min(1),
    })
        .strict()
        .optional(),
})
    .strict();
export const EXTERNAL_SCAN_QUEUE_NAME = "tier0-external-scan";
export function externalScanEnqueueJobId(scanId) {
    return `enr:scan:${scanId}`;
}
//# sourceMappingURL=external-scan-job-payload.js.map